import { Button } from 'reactstrap';
import styles from './ImageCard.module.scss';
import useApiPrivate from '../../../utils/hooks/useApiPrivate';
import { useState, useRef } from 'react';
import { Toast } from 'primereact/toast';

const GALLERY_URL = 'api/v1/gallery';

export default function ImageCard(props) {
    const apiPrivate = useApiPrivate();
    const toast = useRef(null);

    
    const [galleries,setGalleries] = useState(props.galleries);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleDeleteImage = async (id) => {

        try {
            await apiPrivate.delete(GALLERY_URL,{
                params:{
                    id:id
                }
            })
            setGalleries((oldGalleries) => oldGalleries.filter((item) => item.id !== id));
            showSuccess('Photo deleted successfully');
        } catch (error){
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message);
              } 
        }
      }
  
  return (
    <>
        <Toast ref={toast} position="top-center" />
        {
            galleries.length > 0 
                ? <div className={`d-grid ${styles.galleryCards} mb-3`}>
                    {
                        galleries.map((image) => (
                            <div
                                key={image.id} 
                                className={`me-2 text-center p-1 lgtBackground mb-2 ${styles.productImage}`}>
                                <img 
                                    src={`${!image.url ? '/images.png' : `${process.env.REACT_APP_API_URL}${image.url}`}`}
                                    alt="product image"
                                    className={`img-fluid img-thumbnail mb-2`}
                                />
                                <Button 
                                    className={`bg-danger border-0`}
                                    onClick={() => handleDeleteImage(image.id)}
                                    >
                                    <i className='bi bi-trash '></i>
                                </Button>
                            </div>
                        ))
                    }
            </div>
                : <p className="fw-bold">No Image to display</p>
        }
        
    </>
  )
}
